import Text from './Text';

export { default as TextTheme } from './Text.style';
export default Text;
